export default __webpack_public_path__ + "static/media/fourteen.e85d137a.jpg";